import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import { SuggestPeopleRequest, SuggestPeopleResponse } from 'src/types/orbit/People';

export const peopleService = {
  /**
   * Suggest employees matching a login fragment or name. Returns suggestions
   * each carrying a canonical lowercase login (and best-effort display name).
   */
  suggest: (data: SuggestPeopleRequest) => {
    return apiClient.get<SuggestPeopleResponse>(
      ServiceType.ORBIT,
      createApiUrl(API_ENDPOINTS.ORBIT_SERVERICE.PEOPLE.SUGGEST(data.programId)),
      { query: data.query, limit: data.limit },
    );
  },
};
